import React from 'react';

import { Box } from '../../../components/Box/Box';
import { LoadingShimmer } from '../../../components/LoadingShimmer/LoadingShimmer';
import { ROW_DEFAULT_HEIGHT } from '../constants';

export const LoadingCell = () => {
  return (
    <Box flex="auto" h={ROW_DEFAULT_HEIGHT / 2}>
      <LoadingShimmer />
    </Box>
  );
};
